import {
  Directive,
  HostBinding,
  Input,
  OnChanges,
  OnDestroy,
  SimpleChanges
} from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { QuestionsV3 } from '../../classes/enum';

@Directive()
export abstract class QuestionBaseV3ComponentDirective
  implements OnChanges, OnDestroy
{
  @Input() formGroup: UntypedFormGroup;
  @Input() abstract question: QuestionsV3;
  @Input() abstract color: string;

  @HostBinding('class.questionV3_error') errors = false;
  @HostBinding('class.questionV3_isDataToCheck') isDataToCheck = false;

  private questionSubscriptions: Subscription[];

  ngOnChanges(changes: SimpleChanges): void {
    const question: QuestionsV3 =
      changes.question && changes.question.currentValue;

    if (question) {
      this.unsubscribe();
      this.questionSubscriptions = [
        question.errors$.subscribe(v => (this.errors = !!v)),
        question.isDataToCheck$.subscribe(v => (this.isDataToCheck = v))
      ];
    }
  }

  ngOnDestroy(): void {
    this.unsubscribe();
  }

  private unsubscribe(): void {
    if (this.questionSubscriptions) {
      this.questionSubscriptions.forEach(subscription =>
        subscription.unsubscribe()
      );
    }
  }
}
